<template>
  <div id="app">
    <simplert></simplert>
    <loading :active.sync="loading"></loading>
    <nav class="nav navbar-skinny navbar navbar-toggleable-md navbar-inverse bg-info">
      <button class="navbar-toggler navbar-toggler-right"
            type="button"
            data-toggle="collapse"
            data-target="#navbarColor01"
            aria-controls="navbarColor01"
            aria-expanded="false"
            aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <a class="navbar-brand" href="#" v-on:click="toggleSlideoutPanelBtn">
          <i class="icon-Mezzanine_Favicon mezzwings" aria-hidden="true"></i> Portal</a>
      <div class="collapse navbar-collapse" id="navbarColor01">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <a class="nav-link" href="#"><span class="badge badge-pill badge-light">{{signedInAs}}</span></a>
          </li>
        </ul>
        <form class="form-inline" v-on:submit.prevent="">
          <button class="signout-button btn btn-primary btn-sm" v-on:click="toggleSlideoutPanelBtn"><i class="fas fa-bars"></i></button>
          <button class="signout-button btn btn-primary btn-sm" v-on:click="signOutBtn"><i class="fas fa-sign-out-alt"></i></button>
        </form>
      </div>
    </nav>
    
    <vue-slideout-panel v-model="showSlideoutPanel" @close="showSlideoutPanel=false" :widths="['25%']"
      closeHtml="<button class='btn-sm btn-primary'><i class='fas fa-bars'></i></button>">
      <h5 class="text-muted">
        <i class="icon-Mezzanine_Favicon mezzwings text-primary"></i> Portal Features 
      </h5>
      <ul class="list-group list-group-flush">
        <li class="list-group-item"><a class="dropdown-item" href="#/" @click="setSlideoutPanelHidden"><i class="fas fa-home"></i> Home</a></li>
        <li class="list-group-item"><a class="dropdown-item" href="#/apps" @click="setSlideoutPanelHidden"><i class="fas fa-mobile-alt"></i> Apps</a></li>
        <li class="list-group-item"><a class="dropdown-item" href="#/sync" @click="setSlideoutPanelHidden"><i class="fas fa-rocket"></i> Helium-Journey Sync</a></li>
        <li class="list-group-item"><a class="dropdown-item" href="#/dbspy" @click="setSlideoutPanelHidden"><i class="fas fa-user-secret"></i> DB Spy</a></li>
        <li class="list-group-item"><a class="dropdown-item" href="#/schema-access" @click="setSlideoutPanelHidden"><i class="fas fa-unlock-alt"></i> Schema Access</a></li>
        <li class="list-group-item"><a class="dropdown-item" href="#/support-roster" @click="setSlideoutPanelHidden"><i class="fas fa-phone"></i> Support Roster</a></li>
        <li class="list-group-item"><a class="dropdown-item" href="#/helium-dev-latest" @click="setSlideoutPanelHidden"><i class="fas fa-download"></i> Helium Dev Client</a></li>
        <li class="list-group-item" v-if="isProduction"><a class="dropdown-item" href="#/deployments" @click="setSlideoutPanelHidden"><i class="fas fa-cloud-upload-alt"></i> Deployments</a></li>
      </ul>
      <h5 class="text-muted"><i class="fas fa-external-link-alt text-primary"></i> Links</h5>
      <ul class="list-group list-group-flush">
        <li class="list-group-item"><a class="dropdown-item" href="https://monitor.heliumapps.com"><i class="fas fa-tv"></i> Helium Monitor</a></li>
          <li class="list-group-item"><a class="dropdown-item" href="https://wiki.stb.mezzanineware.com/devops-docs/mezzanine-infrastructure/#infrastructure"><i class="fas fa-server"></i> Infrastructure docs</a></li>
        <li class="list-group-item"><a class="dropdown-item" href="https://wiki.stb.mezzanineware.com/display/HD/Helium+DevOps"><i class="fab fa-wikipedia-w"></i> Mezzanine Wiki</a></li>
        <li class="list-group-item"><a class="dropdown-item"href="https://wiki.stb.mezzanineware.com/display/HD/Helium+SPE+Support"><i class="fa fa-ban" aria-hidden="true"></i> Mezzanine Jira</a></li>
        <li class="list-group-item"><a class="dropdown-item" href="https://mezzanineteams.slack.com"><i class="fab fa-slack"></i> Mezzanine Slack channel</a></li>
      </ul>
    </vue-slideout-panel>
    <div id="content" class="container-fluid">
        <sign-in class="signin" v-if="!apps"></sign-in>
        <router-view v-if="apps" ref="homelink"></router-view>
    </div>
    <modal :show.sync="modalSignoutVisibile" :backdrop="modalBackdrop" effect="zoom" large>
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title" v-if="">
          Sign out
        </h4>
      </div>
      <div slot="modal-body" class="modal-body">
        <div class="row">
          <div class="col">
            Going so soon?
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <div class="row">
          <div class="col">
            <button type="button" class="btn btn-default btn-primary" @click="modalSignoutConfirmBtn">Sign me out!</button>
            <button type="button" class="btn btn-default btn-secondary" @click="modalSignoutCloseBtn">Nevermind.</button>
          </div>
        </div>
        
      </div>
    </modal>
  </div>
</template>

<script>
  import SignIn from '@/pages/SignIn'
  import Apps from '@/pages/Apps'
  import { modal } from 'vue-strap'
  import VueSlideoutPanel from 'vue-slideout-panel'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.min.css'
  export default {
    name: 'app',
    components: {
      SignIn,
      Apps,
      VueSlideoutPanel,
      modal,
      Loading
    },
    data () {
      return {
        baseUrl: process.env.BASE_URL,
        year: new Date().getFullYear(),
        displayBackButton: false,
        nav: null,
        socket: null,
        username: null,
        password: null,
        loginError: null,
        apps: null,
        app: null,
        environments: null,
        environment: null,
        heliumBaseUrl: null,
        syncApps: null,
        showSlideoutPanel: false,
        modalSignoutVisibile: false,
        modalBackdrop: false,
        loading: false
      }
    },
    methods: {
      closeWs: function () {
        if (this.socket !== null && this.socket !== undefined) {
          this.socket.close()
        }
      },
      signOutBtn: function () {
        this.modalSignoutVisibile = true
      },
      modalSignoutConfirmBtn: function () {
        this.apps = null
        this.closeWs()
        this.modalSignoutVisibile = false
        this.$router.push({name: 'root'})
      },
      modalSignoutCloseBtn: function () {
        this.modalSignoutVisibile = false
      },
      httpUrlToWebSockeUrl: function (url) {
        if (url.indexOf('http') === 0) {
          return url.replace(/http/, 'ws')
        } else if (url.indexOf('https') === 0) {
          return url.replace(/https/, 'ws')
        }
        return url
      },
      setSlideoutPanelHidden: function () {
        this.showSlideoutPanel = false
      },
      setSlideoutPanelVisible: function () {
        this.showSlideoutPanel = true
      },
      toggleSlideoutPanelBtn: function () {
        this.closeWs()
        if (this.showSlideoutPanel) {
          this.setSlideoutPanelHidden()
        } else {
          this.setSlideoutPanelVisible()
        }
      }
    },
    watch: {
      '$route': function (newRoute) {
        // let vm = this
        // vm.$nextTick(() => {
        // })
      },
      'environment': function (value) {
        this.heliumBaseUrl = value.baseUrl
      }
    },
    created () {
      let vm = this
      window.addEventListener('keydown', function (e) {
        if (e.keyCode === 27) {
          vm.setSlideoutPanelHidden()
          vm.modalSignoutCloseBtn()
        }
      })
    },
    computed: {
      isProduction: function () {
        return this.environment && (this.environment.name === 'Production' || this.environment.name === 'Localhost')
      },
      signedInAs: function () {
        if (!this.environment || !this.username) {
          return 'Not signed in'
        } else {
          return 'Signed into ' + this.environment.name + ' as ' + this.username
        }
      }
    }
  }
</script>

<style>

  #content {
    margin-top: 0.75rem;
  }

  .navbar-skinny {
    padding: 5px 16px 5px 16px !important;
  }

  .signin {
    padding-top: 25px;
  }

  .signout-button {
    border: rgba(166, 219, 255, 0.6) solid 1px !important;
  }

  .mezzwings {
    vertical-align: text-top;
  }

  .card-block-watermark {
    font-size: 2rem;
    position: absolute;
    bottom: 5px;
    right: 5px;
    opacity: 0.3;
  }
</style>



// WEBPACK FOOTER //
// App.vue?1dd47594